import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=7b665ee8&"
import script from "./InputButton.vue?vue&type=script&lang=ts&"
export * from "./InputButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports